import {baseUrl, getQueryParam} from 'src/utils/url';
class GtmDetails {
  constructor() {
    if ($('.pc-Style').length) {
      this.detailEcomEvent = this.detailEcomEvent.bind(this);
      this.swatchSelected = this.swatchSelected.bind(this);
      this.initBehavior();
      if (!this.isDetails()) {
        return;
      }
      this.detailImpression();
      this.detailEcomEvent();
    }
  }

  el() {
    return $('.pc-Style');
  }

  isDetails() {
    return this.el().length > 0;
  }

  data() {
    return this.el().find('.pc-Style-dataLayer').data();
  }

  // Private

  initBehavior() {
    return $(document).on(
      'swatchselect.style.colorinteraction',
      this.swatchSelected
    );
  }

  swatchSelected(e, data) {
    StyleBitz.Utils.delay(100, () => {
      const colorId = [Number(data.colorid)];
      return this.detailImpression(data);
    });
    return undefined;
  }

  detailImpression(swatchData) {
    const data = this.data();
    if (swatchData) {
      data.variant = swatchData.name;
      data.colorid = Number(swatchData.colorid);
      data.colorurl = `${baseUrl()}?PK=${data.colorid}`;
      data.colorimage = `https://mms-images.out.customink.com/mms/images/catalog/colors/${data.colorid}/views/alt/front_small_extended.png`;
    }
    return ProductCatalog.gtmEvent(
      'detailImpression',
      'detailImpression',
      data
    );
  }

  detailEcomEvent() {
    const data = this.el().find('.pc-Style-ecomDataLayer').data();
    const ecommerce = {
      items: [ data.items[0]]
    }
    ProductCatalog.gtmEcomEvent('view_item', ecommerce);
  }
}

jQuery(() => (ProductCatalog.GtmDetails = new GtmDetails()));
